<p-dialog header="Save Search" [(visible)]="saveSearchVisible" [modal]="true" [closable]="false" (onHide)="hideDialog();"
  [style]="{width:'50vw'}">
  <div><p>Your search query will be saved to your <b>DOWNLOADS</b> folder on your computer using the name you specify below.</p>
  <p>You can move, rename for later use as you see fit.  Please do not edit the <em>contents</em> of the file as the search query will not work.</p></div>
  <div class="p-field">
    <label class="mb-3 h6" for="saveSearchName">Saved Search Filename</label>
    <input id="saveSearchName" type="text" class="form-control form-control-lg" pInputText autofocus
      [(ngModel)]="saveSearchName" (ngModelChange)="validateFilename();" placeholder="Enter a filename to save search">
    <small *ngIf="isInvalidFilename" class="text-danger text-strong mt-2"><i class="fas fa-close"></i> Invalid characters in filename.</small>
  </div>
  <div class="float-end">
    <button p-button
      class="btn btn-primary mt-3 mb-3 me-2" (click)="hideDialog();"> <span class="fas fa-circle-xmark"></span> Close</button>
    <button p-button [disabled]="searchNameLength()===0 || isInvalidFilename"
      class="btn btn-secondary mt-3 mb-3" (click)="executeSavedSearch()"> <span class="pi pi-save"></span> Save
      Search</button>
  </div>
</p-dialog>